import { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { useData } from '../context/data.context';

type SensorPropereties = {
  sensorType: string;
  noOfSensors: number;
};

/**
 * Component that displays No of Sensors.
 * @param props - Properties of the Sensor Component.
 * @returns  A Sensor component that represents No of Sensor.
 */
function Sensor(props: SensorPropereties): ReactElement {
  const { sensorType, noOfSensors } = props;

  /**
   * A function for getting the classes based on the sensor type.
   * @param type - Type of sensor.
   * @returns Clasess.
   */
  const getClasses = (type: string): string => {
    if (type === 'working') {
      return 'text-success-500';
    }
    if (type === 'moderate') {
      return 'text-warning-500';
    }
    if (type === 'default') {
      return 'text-error-500';
    }
    return '';
  };

  return (
    <div className="flex items-center text-xs font-medium text-gray-400 dark:text-gray-300">
      <span className={`material-icons ${getClasses(sensorType)} text-sm px-0.5`}>circle</span>
      {noOfSensors}
    </div>
  );
}

/**
 * A Sensors component that returns list of sensors.
 * @returns Diffrent type of sensor.
 */
export default function Sensors(): ReactElement {
  const { dataRatePerDevice } = useData();

  const dataRate = {
    working: dataRatePerDevice
      ? Object.values(dataRatePerDevice).filter((item: any) => item.state === 'working')?.length
      : 0,
    moderate: dataRatePerDevice
      ? Object.values(dataRatePerDevice).filter((item: any) => item.state === 'moderate')?.length
      : 0,
    default: dataRatePerDevice
      ? Object.values(dataRatePerDevice).filter((item: any) => item.state === 'default')?.length
      : 0
  };

  return (
    <NavLink
      to="/settings/device-setup?tab=devices"
      className="flex justify-center items-center gap-3 border w-full border-gray-200 p-1 lg:p-2 rounded dark:border-gray-800 mr-0 lg:mr-6"
    >
      <div className="flex items-center gap-3 text-sm text-gray-400 font-medium dark:text-gray-300">
        <span className="material-icons">wifi</span>
      </div>
      <div className="flex gap-4 mr-2">
        {Object.entries(dataRate).map(([key, value]) => (
          <Sensor key={key} noOfSensors={value} sensorType={key} />
        ))}
      </div>
    </NavLink>
  );
}
